import service from './http'
import serve from "@/utils/serve";
import {Access, Account} from "@/types/Access";

/**
 * As contas do lunedi e a admissão de cada uma.
 *
 * Recurso de aplicação, e não de ambiente: ele mora fora de `/systems/...` e tem portão próprio
 * no servidor, que exige aprovador pelo caminho. A conta é apontada pelo id (`user`), e não pelo
 * e-mail, que muda.
 */
class InvitationService {
    /** Todas as contas, com as pendentes no alto — quem ordena é o servidor. */
    async list(): Promise<Account[]> {
        return await serve(async () => await service.get('invitations'))
    }

    async setAccess({user}: { user: number }, access: Access): Promise<Account> {
        return await serve(async () => await service.patch(`invitations/${user}`, {access}))
    }
}

export default InvitationService
